export default "__VITE_ASSET__CgBPSNxo__"